/**
 * Utility functions for handling form template endpoints based on environment
 */

export enum FormTemplateType {
  PRODUCTION = 'FormTemplate',
  TEST = 'FormTemplate',
  STAGING = 'FormTemplateStaging',
  DR = 'FormTemplateDr'
}

export enum Environment {
  PRODUCTION = 'prod',
  TEST = 'test',
  STAGING = 'staging',
  DR = 'resto' // TODO: Change to dr_resto, discuss with infra team later, used for DR environment
}

/**
 * Gets the correct form template endpoint based on the current environment
 * @returns The form template endpoint path
 */
export const getFormTemplateEndpoint = (): string => {
  const env = process.env.NEXT_PUBLIC_ENV

  switch (env) {
    case Environment.TEST:
      return `/form-templates/${FormTemplateType.TEST}`
    case Environment.STAGING:
      return `/form-templates/${FormTemplateType.STAGING}`
    case Environment.PRODUCTION:
      return `/form-templates/${FormTemplateType.PRODUCTION}`
    case Environment.DR:
      return `/form-templates/${FormTemplateType.DR}`
    default:
      return `/form-templates/${FormTemplateType.TEST}`
  }
}

/**
 * Gets the form template type based on the current environment
 * @returns The FormTemplateType enum value
 */
export const getFormTemplateType = (): FormTemplateType => {
  const env = process.env.NEXT_PUBLIC_ENV

  switch (env) {
    case Environment.TEST:
      return FormTemplateType.TEST
    case Environment.STAGING:
      return FormTemplateType.STAGING
    case Environment.PRODUCTION:
      return FormTemplateType.PRODUCTION
    case Environment.DR:
      return FormTemplateType.DR
    default:
      return FormTemplateType.TEST
  }
}

/**
 * Builds a complete form template URL with query parameters
 * @param templateId - The template ID
 * @param restaurantId - The restaurant ID
 * @param formTemplateName - The form template name
 * @returns The complete form template URL
 */
export const buildFormTemplateUrl = (templateId: string, restaurantId: string, formTemplateName: string): string => {
  const endpoint = getFormTemplateEndpoint()

  return `${endpoint}?templateId=${templateId}&restaurantId=${restaurantId}&formTemplateName=${formTemplateName}`
}
